/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
import { BidPlacedBySchema } from '../enums/BidPlacedBy.schema';
import { DecimalSchema } from '../common';
import { Decimal } from 'decimal.js';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    currentBidAmount: DecimalSchema,
    placedBy: BidPlacedBySchema,
    maxBidAmount: DecimalSchema,
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    currentBidAmount: DecimalSchema,
    placedBy: BidPlacedBySchema,
    maxBidAmount: DecimalSchema,
}
).strict();
const relationSchema = z.object({
    auction: z.record(z.string(), z.unknown()),
    propertySeeker: z.record(z.string(), z.unknown()),
    won: z.record(z.string(), z.unknown()).optional(),
}
);
const fkSchema = z.object({
    auctionId: z.string(),
    propertySeekerId: z.string(),
}
);

/**
 * `Bid` schema excluding foreign keys and relations.
 */
export const BidScalarSchema = baseSchema;


/**
 * `Bid` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const BidSchema = BidScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const BidPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const BidPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    currentBidAmount: DecimalSchema,
    placedBy: BidPlacedBySchema,
    maxBidAmount: DecimalSchema
}).partial().passthrough();


/**
 * `Bid` schema for create operations excluding foreign keys and relations.
 */
export const BidCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true
});


/**
 * `Bid` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const BidCreateSchema = BidCreateScalarSchema.merge(fkSchema);


/**
 * `Bid` schema for update operations excluding foreign keys and relations.
 */
export const BidUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Bid` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const BidUpdateSchema = BidUpdateScalarSchema.merge(fkSchema.partial());

